import axios from "axios";

// 创建axios实例
const service = axios.create({
  baseURL: "https://media.iwshang.com/iwshang",
  timeout: 60000, // 请求超时时间
});

export default service;
